<template>

	<div id="chain-graph" style="position: relative;" >

	</div>
</template>
<script>
	import $ from "jquery";
	export default {
		name: 'chain',
		data() {
			return {
				// islogin:false, 
				curWebsite:this.$api.getWebsiteType(),
				chainId: 8,
				gv: null,
				iswhole:true,
				userdata:{},
			}
		},
		props: {
			graphData: String,
			type:String,
			nodelistprops:{required: false,default:[],},//当地图谱专用
		}, 
		mounted() { 
			this.userdata = this.getuseriformation();
			var targetEnterpriseName='相关企业推荐';
			var keyword=(this.curWebsite.type == 4 ||this.curWebsite.type == 2) ? '投资':'招商';
			// console.log('aaaa',this.curWebsite)
			this.iswhole=this.type!='local'; 
			if (this.graphData) { 
				this.initGraph(this.graphData,	this.nodelistprops,targetEnterpriseName,keyword);
				// console.log('this.graphData',this.graphData);
			} 
			let draggable = document.getElementById("chain-graph");
			draggable.addEventListener("touchstart", this.moveGraph());
			// console.log('	this.iswhole', 	this.iswhole);
		},
		methods: {
			moveGraph() {
				// 获取你想要修改的SVG元素，‌这里假设它的ID是"mySvgElement"
				var svgElement = document.querySelectorAll("[transform]");
				console.log('svg元素',svgElement);
				// 移除transform属性
				if(svgElement){
					svgElement[0].style.transform = ""; // 将transform属性设置为空字符串

				}
			},
			initGraph(graphData,nodelistprops,morename,keyword) {
				var _this = this;
				// console.log(graphData);
				var gv = new GraphViewer('chain-graph', 0, graphData);
				var iswholes=this.iswhole;
				var isInBox=false;
				window.showOrange = false;
				window.showgreen = false;
				$(function() {
					if(iswholes){ 
						//全国产业链专用
					gv.hover(function(svg, nodeId) {
						//					console.log("hover:", nodeId); 
						chainFixedBox(nodeId, svg,keyword); 
					}, function(svg, nodeId) {
						setTimeout(function(){
							if(isInBox){return;}
							$('.chain_inportant_company').stop().hide();
						},300)
						
						//					console.log("out:", nodeId); 
					}); 
					setTimeout(function() {
						var idlist = $(".chainpoint .greenbd").attr("idlist").split(',');
						$(".chainpoint .greenbd").attr("node").split(',').forEach((id, i) => {
							gv.nodeClick(id, function() {
								var url = "/#/chain?id=" + idlist[i];
								window.open(url);
							});
						});
					}, 1000);

					setTimeout(function() {
						keychainpoint('.chainpoint .orangebd', '#ff6600');
						keychainpoint('.chainpoint .greenbd', '#238e83');
					}, 1000);
					}else{
						//本地图谱产业链专用 鼠标移上显示企业列表
						// console.log('本地图谱产业链专用 只有鼠标移上显示企业列表');
						setTimeout(function() {
							keychainpoint('.chainpoint .orangebd', '#ff6600');
							keychainpoint('.chainpoint .greenbd', '#238e83');
							keychainpoint('.chainpoint .bluebd', '#4691ad');
						}, 2000);
					 //鼠标移上显示弹框
						gv.hover(function(svg, nodeId) {
												// console.log("hover:", nodeId); 
							chainfixedboxLocal(nodelistprops,nodeId, svg,morename);
						}, function(svg, nodeId) {
						setTimeout(function(){
							if(isInBox){return;}
							$('.chain_inportant_company').stop().hide();
						},300)
						});
						
					}
					$('.chain_inportant_company').hover(function() {
						isInBox=true;
						$(this).show();
					}, function() {
						isInBox=false;
						$(this).hide();
					})
					
				});
				window.keychainpoint = function(obj, color) {
					if(!$(obj).attr("node")){return ;}
					$(obj).toggleClass('current'); 
					var nodeList = $(obj).attr("node").split(',');
					showgreen = $(obj).hasClass('current');
					if (showgreen) { 
						gv.setColor(nodeList, '#fff', color, color); //文字颜色，背景色，边框色
					} else {
						gv.setColor(nodeList); //恢复
					}
				}
			
				window.chainfixedboxLocal=function(nodelistd,nodeid, obj,targetEnterpriseName){
					
					// console.log('localnodelistd',nodelistd);
						var boxoffset = $('.chain-graph-wrap').offset();
					// console.log(nodeid);
					var offsets = $(obj).offset(),nodecompanylist=[],nodetitle='',notioncode="",nodecompanyNum=0;
					var objWidth = $(obj).children('rect').attr('width') * 1, objHeight = $(obj).children('rect').attr('height') * 1;
					var poleft = offsets.left - boxoffset.left + objWidth - 20, 	potop = offsets.top - boxoffset.top + objHeight - 20;
					for(var i=0;i<nodelistd.length;i++){
						// console.log(nodelistd[i].nodeId,nodeid,nodelistd[i].nodeId == nodeid)
						if(nodelistd[i].nodeId == nodeid){ 
							nodecompanylist=nodelistd[i].enterpriseList;
							nodecompanyNum=nodelistd[i].enterpriseNum;
							nodetitle=nodelistd[i].nodeName;
							notioncode=nodelistd[i].notionCode;
							// return;
						}
					}
					// console.log('1',nodecompanylist.length);
					if(nodecompanylist.length>0 && objWidth != "NaN"){
						// console.log('企业有数值',this.curWebsite);
					
						$(obj).css('cursor', 'pointer');
						var ahtnk="";
						for(var d=0;d<nodecompanylist.length;d++){
							var starTag='',redclasname="";
							if(nodecompanylist[d].areaKey == _this.userdata.areaKey){ //24.6.13之前nodecompanylist[d].areaKey>0
								starTag='<em class="redfont starTag">*</em>';
								redclasname="redfont";
							}
						ahtnk=ahtnk+'<a href="/#/enterprises?id='+nodecompanylist[d].stockCode+'" target="_blank" class="company_name '+redclasname+'">'+nodecompanylist[d].title+starTag+'</a>'
						};
						var clickmorelink=nodecompanyNum>10?'<a class="targetlink" target="_blank" href="/#/localChainMoreEnterprise?type=0&key=notion&id='+notioncode+'&keyword='+nodetitle+'">查看更多</a>':'';
						ahtnk=ahtnk+'<div class="oh">'+clickmorelink+'<a class="targetlink1" target="_blank" href="/#/targetEnterprise?type=0&key=notion&id='+notioncode+'&keyword='+nodetitle+'">'+targetEnterpriseName+'>></a></div>';
						if($('.chain_inportant_company').length>0){
							$('.chain_inportant_company .botcompanybox').html(ahtnk);  
							$('.chain_inportant_company .title-blue').html(nodetitle+'('+nodecompanyNum+')');  
						}else{
							$('.chain-graph-wrap').append('<div  class="chain_inportant_company "><h4  class="title title-blue">'+nodetitle+'('+nodecompanyNum+')</h4><div  class="box"><div class="botcompanybox oh localchainpops">'+ahtnk+'</div></div></div>');
						}
							
						$('.chain_inportant_company').stop(false,true).animate({
							'left': poleft + 'px',
							"top": potop + "px", 
						}).show();
					}else{
						$('.chain_inportant_company').hide();
					}
				}
				window.replaceAllFun=function(str, find, replace) {
					return str.replace(new RegExp(find, 'g'), replace);
					// console.log(str, find, replace)
				}
				window.chainFixedBox = function(nodeid, obj,keyword) {
					// alert('chainFixedBox'+nodeid + obj + keyword)
					console.log('chainFixedBox',nodeid , obj , keyword);
					var blockWidth=$('.chain-graph-wrap').width();
					var boxoffset = $('.chain-graph-wrap').offset();
					// console.log( $(obj).children('rect').attr('width') );
					var offsets = $(obj).offset();
					var objWidth = $(obj).children('rect').attr('width') * 1,
					 objX = $(obj).children('rect').attr('x') * 1,
					 objY = $(obj).children('rect').attr('y') * 1,
						objHeight = $(obj).children('rect').attr('height') * 1; 
						var poleft = objX, potop = offsets.top - boxoffset.top + objHeight - 10;
						
					// var poleft = offsets.left - boxoffset.left + objWidth - 20,
					// 	potop = offsets.top - boxoffset.top + objHeight - 20; 
					var hasJiedian = $('.node-' + nodeid).length > 0;
					var datamarket = $('.node-' + nodeid).eq(0).attr('data-market');
					datamarket=replaceAllFun(datamarket,'招商',keyword);
				 
					var datanewcompany = $('.node-' + nodeid).eq(0).attr('data-company');
					var datacompany = $('.node-' + nodeid + ' .company_name');
					var htmltablecompany = "",
						htmlnewcompany = "",
						htmlmarket = "";
					var htmls = "",
						htmltable = "",
						boxtitle = [],
						companylink = "",
						companylink1 = ""; 
					if (hasJiedian && objWidth != "NaN") {
						$(obj).css('cursor', 'pointer');
						
						if ($('.node-' + nodeid + ' .company_name').length > 0 && $('.node-' + nodeid + 	' .company_name').eq(0).html() != "") {
							$('.node-' + nodeid + ' .company_name').each(function() {
								companylink = companylink + this.outerHTML;
							});
							if (htmls != "") {
								htmls = htmls +
									'<div class="chaincom-bot"><h3 class="title">重点公司</h3><div class="botcompanybox">' +
									companylink + '</div></div>'
							} else {
								htmls = '<div class="botcompanybox oh">' + companylink + '</div>';
								boxtitle.push('重点公司');
							}
       if($('.node-' + nodeid + ' .company_name').length<4){
								poleft=poleft+40;
							}
						}
						if (datanewcompany != undefined && datanewcompany.length != 0) {
							eval("var datanewcompany=" + datanewcompany);
							//						datanewcompany=JSON.parse(datanewcompany);   
							for (var i = 0; i < datanewcompany.length; i++) {
								companylink1 += '<a href="' + datanewcompany[i].url +
									'" target="_blank" class="company_name">' + datanewcompany[i].name + '</a>';
							}

							if (htmls != "") {
								htmls = htmls +
									'<div class="chaincom-bot"><h3 class="title">新兴公司</h3><div class="botcompanybox">' +
									companylink1 + '</div></div>';
							} else {
								htmls = '<div class="botcompanybox oh">' + companylink1 + '</div>';
								boxtitle.push('新兴公司');
							}
						}
						if (datamarket != undefined && datamarket.length != 0) {
							datamarket = JSON.parse(datamarket);
							for (var i = 0; i < datamarket.length; i++) {
								var dataxy = datamarket[i].data;
								for (var d = 0; d < dataxy.length; d++) {
									if (d == 0) {
										htmltable += '<tr class="trline' + (i + 1) + '"><td rowspan="' + dataxy
											.length + '" class="firstth">' + datamarket[i].name + '</td><td>' + dataxy[
												0].name + '</td><td>' + dataxy[0].datay + '</td></tr>'
									} else {
										htmltable += '<tr class="trline' + (i + 1) + '"><td>' + dataxy[d].name +
											'</td><td>' + dataxy[d].datay + '</td></tr>';
									}
								}
							}
							if (htmls != "") {
								htmls = htmls+ '<h3 class="title">市场机会评估</h3> '+
										'<table border="0" cellspacing="0" cellpadding="0" width="100%">' + htmltable + '</table>'
							}else{
								htmls = htmls+'<table border="0" cellspacing="0" cellpadding="0" width="100%">' + htmltable + '</table>';
							}
							
							boxtitle.push('市场机会评估');
							if(poleft>1000){
								poleft=980;
							}
						}
						//console.log(htmls); 
						if (htmls != "") {
							$('.chain_inportant_company .title').eq(0).text(boxtitle[0]); 
							$('.chain_inportant_company .box').html(htmls);
							// console.log(poleft,potop);
							// $('.chain_inportant_company').css({
							// 	'left': poleft + 'px',
							// 	"top": potop + "px"
							// }).stop(false,true).fadeIn();
							$('.chain_inportant_company').stop(false,true).animate({
								'left': poleft + 'px',
								"top": potop + "px", 
							}).show();
						}
					} else {
						$('.chain_inportant_company').hide();
					}
				}
			},

		},

	}
</script>

<style>
svg:not(:root) { overflow: auto;pointer-events: none;}
g[transform ~= translate]{
	transform: translate(0, 0) !important;
	background-color: darkblue;


}
div[title = ddd]{
	color: red;
	/* background-color: darkblue; */
}
</style>
